function BrandImg(props) {
  return (
    <div className="rounded-2xl shadow-lg m-1 flex justify-center items-center">
      <img src={props.src} alt="" className="w-1/2 h-2/3" />
    </div>
  );
}
export default BrandImg